import { ComboBox, DefaultButton, PrimaryButton,Label, Icon, IComboBoxOption, IIconProps, TooltipHost, TextField } from "@fluentui/react";
import { getLocalizedStrings } from "../../lib/LocalizedStringsForDatePicker";
import { CustomDatePicker } from "./ImportAct";
import { User } from "../../system/User";
import { IactError, ItipoConceptoGrid } from "./InterfaceTabla";
import { t } from "i18next";
import MessageCourier from "../../lib/MessageCourier";

interface ICustonearder{
  filteredCollaborators: IComboBoxOption[];
  collaboratorValue:string;
  handleSelectCollaborator:(option: IComboBoxOption | undefined) => Promise<void>;
  handleFilterCollaborator:(text: string) => void;
  periodo:Date;
  HandlerPeriodo:(date: Date) => void;
  horasTotal:number;
  convertMinToHour:(minutes: number) => string;
  desabled:boolean;
  UploadIcon:IIconProps;
  actError:IactError;
  tipoConcept:ItipoConceptoGrid[];
  desableAddRow:boolean;
  HandlerDuplicateRows:() => void;
  AddIcon:IIconProps;
  dataUser:User;
  mountBlock: {[key: number]: number[]};
  HandlercleanEverything:() => void;
  addrowlength:number;
  courier: MessageCourier;
  handleChangeNumberNewRows: (value: string | undefined) => void;
}

const Custoneader = ({
    filteredCollaborators,
    collaboratorValue,
    handleSelectCollaborator,
    handleFilterCollaborator,
    periodo,
    HandlerPeriodo,
    horasTotal,
    convertMinToHour,
    desabled,
    UploadIcon,
    actError,
    tipoConcept,
    desableAddRow,
    HandlerDuplicateRows,
    AddIcon,
    dataUser,
    mountBlock,
    HandlercleanEverything,
    addrowlength,
    courier,
    handleChangeNumberNewRows
  }:ICustonearder) =>{

    return (
      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg7">
            <ComboBox
              label={t("Colaborador")}
              className="ms-Grid-col ms-sm4 ms-md6 ms-lg4"
              options={filteredCollaborators}
              allowFreeform
              text={collaboratorValue}
              onChange={(_, option) => handleSelectCollaborator(option)}
              onInputValueChange={(text) =>
                handleFilterCollaborator(text || "")
              }
              selectedKey={"00000006454"}
              disabled={dataUser.isDirectiveUser() || dataUser.isStandardUser()}
            />
            <CustomDatePicker
              strings={getLocalizedStrings()}
              label={t("Periodo")}
              value={periodo}
              blockedMonths={mountBlock}
              onSelectDate={(date) => HandlerPeriodo(date as Date)}
            />
            <div className="ms-Grid-col ms-sm4">
              <Label>{t("Horas pendientes")}</Label>
              <DefaultButton
                style={{
                  color: horasTotal > -1 ? "black" : "red",
                  border: "none",
                }}
              >
                {convertMinToHour(horasTotal)}
              </DefaultButton>
            </div>
          </div>
          <div
            className="ms-Grid-col ms-sm12 ms-md6 ms-lg4"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "20px",
              marginTop: "20px",
            }}
          >
            <PrimaryButton
              className="ms-Grid-col ms-sm12 ms-md6 ms-lg3"
              text={t("Cargar")}
              iconProps={UploadIcon}
              type="submit"
              disabled={desabled}
            />
          </div>
        </div>
        <div className="ms-Grid-col ms-sm12">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              padding: "20px 20px",
            }}
          >
            <Icon iconName="Info" style={{ marginRight: "5px" }} />
            <div className="ml-2">
              <li className="mb-1">
                {t("Los documentos serán cargados al proyecto/servicio")}
              </li>
              <li>
                {t(
                  "El 100% de la carga de la actividad irá a la empresa seleccionada"
                )}
              </li>
              <li>{t("(*) campo obligatorio")}</li>
            </div>
          </div>
        </div>
        <div className="ms-Grid-row" style={{ padding: "0px 30px" }}>
          <div
            className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              className="ms-Grid-col ms-sm12 ms-md9"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "10px",
              }}
            >
              <PrimaryButton
                disabled={addrowlength === 0 ? true : false}
                text={t("Duplicar fila(s)")}
                iconProps={AddIcon}
                onClick={() => HandlerDuplicateRows()}
              />
              <PrimaryButton
                disabled={addrowlength === 0 ? true : false}
                text={t("Eliminar fila(s)")}
                onClick={() => HandlercleanEverything()}
                iconProps={{ iconName: "Delete" }}
              />
              <TextField
                placeholder={"Agregar filas"}
                onChange={(e, newValue) => handleChangeNumberNewRows(newValue)}
                autoAdjustHeight
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault(); // Evita el submit del form
                  }
                }}
                styles={{
                  fieldGroup: { minHeight: 20 },
                  field: { whiteSpace: "pre-wrap" },
                  root: {
                    width: 100,
                  },
                }}
                rows={1}
              />
            </div>
          </div>
        </div>
      </div>
    );};
  export default Custoneader;